// pubkey self
import selfHtml from './s30-pubkey_self.html' with { type: 'text' };;

import { mod_loader,KeyDetailsModule, InviteModule,MsgComposeModule } from "../AppState.js"

import { get_pub_key } from "../crypt_helper.js";

import { navbar_active_menu } from '../utils.js';

var root

export async function init(module_root) {

    module_root.innerHTML = selfHtml;

    root = module_root

    root.querySelector(".btn_invite_recipient").addEventListener('click', () => mod_loader(InviteModule));

    root.querySelector(".btn_msg_compose").addEventListener('click', () => mod_loader(MsgComposeModule));

    await mod_loader(KeyDetailsModule, { target: ".div_key_details", 'key': await get_pub_key() })

    navbar_active_menu(".navbar_pubkey_self")
    
}
